import React from "react";

export function CheckBox({ label, Value, defaultValue, onValueChange,name }: { label: string, Value?: boolean, defaultValue?: boolean, name:string, onValueChange: (name:string,val: boolean) => void }) {
    const toggleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onValueChange(name, event.target.checked);
    }

    return (
        <div className="flex flex-row">
            <div className="flex flex-col p-2">
                <input type="checkbox" value={label.toLowerCase()} onChange={toggleCheckboxChange} checked={Value} defaultChecked={defaultValue} />
            </div>
            <div className="flex flex-col px-1 py-1">
                <label className="text-sm">{label}</label>
            </div>
        </div>
    );
}